import { withStaticProperties } from '@tamagui/core';

import { Actions } from './Actions';
import type { DialogActionsProps } from './Actions';
import { Content } from './Content';
import type { DialogContentProps } from './Content';
import { Dialog as DialogFrame } from './Dialog';
import type { DialogProps } from './Dialog';

const Dialog = withStaticProperties(DialogFrame, {
  Content,
  Actions,
});

export { Dialog };
export type { DialogProps, DialogContentProps, DialogActionsProps };
